import React from "react";
import styles from "../style.module.css";

function EmptyData(props) {
  return <span className={styles.emptyData}>Список пуст...</span>;
}

export default EmptyData;
